export default "/images/f1065716731442f7741ded5021a199a3.avif";